import constants from './constants';

export const genIdentityAppTag = (tag: string) => {
	const normalizedTag = tag.trim().toLowerCase();

	return {
		appMetaData: {
			id: normalizedTag,
			tag: normalizedTag,
			entryPoint: `${normalizedTag}.js`,
		},
	};
};

export const resolveIdentityAppTag = (
	baseTag: string,
	designSystem?: string,
) => {
	const normalizedDesignSystem = designSystem?.trim();
	const shouldAppendDesignSystem =
		!!normalizedDesignSystem &&
		normalizedDesignSystem.toLowerCase() !== constants.DEFAULT_DESIGN_SYSTEM;

	return shouldAppendDesignSystem
		? `${baseTag}-${normalizedDesignSystem}`
		: baseTag;
};
